// File upload and size limits

/**
 * Maximum file upload size in megabytes
 * This should match the server-side max_upload_size configuration
 */
export const MAX_FILE_SIZE_MB = 500;

/**
 * Default fallback for m.upload.size in bytes (500MB)
 * Used when media config endpoint fails or returns no limit
 */
export const DEFAULT_UPLOAD_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

/**
 * Maximum avatar file size in bytes (5MB)
 * Used for profile and room avatar uploads
 */
export const MAX_AVATAR_SIZE_MB = 5;
export const MAX_AVATAR_SIZE_BYTES = MAX_AVATAR_SIZE_MB * 1024 * 1024;

/**
 * Allowed image MIME types for avatar uploads
 * Using an explicit allowlist prevents MIME type spoofing attacks
 * that could occur with generic image/* checks
 */
export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];

/**
 * Maximum number of pinned messages allowed per room
 * This is a client-side UX constraint; the Matrix server does not enforce this limit
 */
export const MAX_PINS_PER_ROOM = 3;
